"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const technologies = [{
  name: "Google Cloud",
  description: "Ihre Website läuft auf der gleichen Infrastruktur wie Google, YouTube und Spotify. Schnell, sicher, weltweit verfügbar.",
  logo: "https://upload.wikimedia.org/wikipedia/commons/5/51/Google_Cloud_logo.svg"
}, {
  name: "WordPress",
  description: "Das beliebteste CMS der Welt – über 40% aller Websites nutzen es. Riesige Community, tausende Plugins, kein Vendor Lock-in.",
  logo: "https://upload.wikimedia.org/wikipedia/commons/9/98/WordPress_blue_logo.svg"
}, {
  name: "Cloudflare",
  description: "Globales CDN für blitzschnelle Ladezeiten. DDoS-Schutz und SSL inklusive – Ihre Website ist immer erreichbar.",
  logo: "https://upload.wikimedia.org/wikipedia/commons/9/94/Cloudflare_Logo.png"
}];
export default function GlobaleEngineeringStandards() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="145361" id="technologie" className="bg-muted/30 py-24 overflow-hidden">
      <div ref={ref} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-6">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-4">
            Unsere Technologie betreibt weltweit über 2 Millionen Webseiten
            – jetzt auch für Schweizer KMU verfügbar.
          </h2>
        </div>
        <p className="text-center text-lg text-muted-foreground max-w-2xl mx-auto mb-16">
          Wir setzen auf bewährte Technologien, die auch die grössten
          Unternehmen der Welt nutzen. Keine eigengebauten CMS-Systeme, die
          niemand kennt – sondern Standards, denen Millionen vertrauen.
        </p>

        {/* Tech Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {technologies.map((tech, i) => <div key={tech.name} data-index={i} className="bg-background border border-border rounded-xl p-8 text-center hover:shadow-lg hover:border-primary/50 transition-all duration-300">
              <div className="flex items-center justify-center h-16 mb-6">
                <img src={tech.logo} alt={`${tech.name} Logo`} className="max-h-12 w-auto object-contain" loading="lazy" />
              </div>
              <h3 className="text-xl font-bold text-foreground mb-3">
                {tech.name}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {tech.description}
              </p>
            </div>)}
        </div>

        {/* Trust bar */}
        <div className="text-center">
          <p className="text-sm text-muted-foreground">
            Keine Experimente, keine unbekannten Systeme. Bewährte Technologie,
            die performant, sicher und zukunftsfähig ist.
          </p>
        </div>
      </div>
    </section>;
}